// PATH: src/routes/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTilmiAuth } from '../hooks/useTilmiAuth';
import ChangePasswordRequired from '../pages/auth/auth/ChangePasswordRequired';

interface ProtectedRouteProps {
    requiredRoles?: string[];
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRoles, children }) => {
    const { status, isLoading, isRoleExist, user } = useTilmiAuth();

    if (isLoading || status === "unknown") return null;

    if (status !== "authenticated") {
        return <Navigate to="/" replace />;
    }

    // Mot de passe provisoire : le compte a été créé par une école avec un mot
    // de passe partagé par tous ses élèves. Tant qu'il n'en a pas choisi un à
    // lui, aucune route protégée ne s'ouvre.
    //
    // L'écran est RENDU ici plutôt que redirigé vers une route dédiée : une
    // route de plus serait une route de plus à oublier de protéger, et une URL
    // que l'on peut quitter à la main. Rendu à la place du contenu, il n'y a
    // aucune adresse à contourner — et la barre d'adresse garde la destination
    // demandée, donc l'utilisateur y arrive une fois son mot de passe changé.
    //
    // Le drapeau vient de GET /me (et non de la seule réponse de login), donc
    // il survit à un rechargement de page.
    if (user?.user?.must_change_password) {
        return <ChangePasswordRequired />;
    }

    if (requiredRoles && !requiredRoles.some(role => isRoleExist(role))) {
        return <Navigate to="/access-denied" replace />;
    }

    return children;
};

export default ProtectedRoute;
